import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { AppSidebarNav } from '@coreui/react';
import { NavItem } from 'reactstrap';
import './MainMenu.scss';
import Translate, { translate } from '../../../../i18n/Translate';
import { OpportunityWizard } from '../../../../views/Pages/Investment';
import { MixPanel } from '../../../../utils/helpers/mixPanel';
import { configs } from '../../../../config';

const MainMenu = (props) => {
  const {
    className, pathname, authenticated, isAuthenticated, issuerLogo, user, hasOpportunities,
  } = props;
  const isWizard = pathname && isAuthenticated && pathname.startsWith('/opportunity')
    && pathname.includes('investment') && !configs.ENABLE_INVESTMENT_MFE;
  const isActive = (pathName) => new RegExp(`^/${pathName}$`, 'i').test(pathname);
  return (
    <AppSidebarNav className={classnames(isWizard ? 'wizard-menu' : 'main-menu-nie', className)}>
      { !isWizard
        && (
        <NavItem className="logo-nav-securitize">
          <Link id="logo" to="/">
            <img src={issuerLogo} className="nav-img-avatar" alt={translate('Texts.securitize')} />
          </Link>
        </NavItem>
        )}
      {
        !authenticated ? '' : isWizard ? (
          <OpportunityWizard />
        ) : (
          <>
            <NavItem active={isActive('home')}>
              <Link id="home-page-nav" to="/home">
                <i className="nav-img-action icon-home mt-5" />
                <span className="main-menu-nie__title">
                  <Translate translationKey="Texts.home" />
                </span>
              </Link>
            </NavItem>
            {hasOpportunities
            && (
              <>
                <NavItem active={isActive('Opportunities')}>
                  <Link
                    id="opportunities-page-nav"
                    to="/opportunities"
                    onClick={() => {
                      MixPanel.track('opportunities-click',
                        {
                          type: user.investorType,
                          KYCState: user.verificationStatus,
                          country: user.countryCode,
                        });
                    }}
                  >
                    <i className="nav-img-action icon-market mt-5" />
                    <span className="main-menu-nie__title">
                      <Translate translationKey="Texts.opportunities" />
                    </span>
                  </Link>
                </NavItem>
              </>
            )}
            <NavItem active={isActive('portfolio')}>
              <Link id="portfolio-page-nav" to="/portfolio">
                <i className="nav-img-action icon-portfolio mt-5" />
                <span className="main-menu-nie__title">
                  <Translate translationKey="Texts.portfolio" />
                </span>
              </Link>
            </NavItem>
            <NavItem active={isActive('documents')}>
              <Link id="documents-page-nav" to="/documents">
                <i className="nav-img-action icon-document mt-5" />
                <span className="main-menu-nie__title">
                  <Translate translationKey="Texts.documents" />
                </span>
              </Link>
            </NavItem>
            {
              user.liquidityEnabled
              && (
                <>
                  <NavItem active={isActive('liquidity')}>
                    <Link id="home-page-liquidity" to="/liquidity">
                      <i className="nav-img-action icon-liquidity mt-5" />
                      <span className="main-menu-nie__title">
                        <Translate translationKey="Texts.liquidity" />
                      </span>
                    </Link>
                  </NavItem>
                </>
              )
            }
          </>
        )
      }
    </AppSidebarNav>
  );
};

MainMenu.propTypes = {
  className: PropTypes.string,
  pathname: PropTypes.string,
  authenticated: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  issuerLogo: PropTypes.string,
  hasOpportunities: PropTypes.bool,
  user: PropTypes.objectOf(PropTypes.any),
};

MainMenu.defaultProps = {
  issuerLogo: '',
  className: '',
  pathname: '/',
  authenticated: false,
  isAuthenticated: false,
  hasOpportunities: true,
  user: {},
};

const mapStateToProps = ({
  auth: { isAuthenticated, user }, issuerConfiguration: {
    config:
  { hasFAQs, hasOpportunities },
  },
}) => ({
  isLoading: false,
  isAuthenticated,
  hasFAQs,
  hasOpportunities,
  user,
});

export default connect(
  mapStateToProps,
  {},
)(withRouter(MainMenu));
